/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Starting_InfoInputs */

const en_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing team project with Junction. This may take a moment...`)
};

const fr_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation du projet d’équipe avec Junction. Cela peut prendre un moment...`)
};

const de_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Teamprojekt wird mit Junction synchronisiert. Dies kann einen Moment dauern…`)
};

const it_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione del progetto di gruppo con Junction. L'operazione potrebbe richiedere qualche istante...`)
};

const ru_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация командного проекта с Junction. Это может занять некоторое время...`)
};

const es_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando proyecto de equipo con Junction. Puede tardar un momento...`)
};

const zh_cn2_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在将团队项目与 Junction 同步。这可能需要一些时间……`)
};

const ja_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトをJunctionと同期しています。少々時間がかかる場合があります。`)
};

const hi_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट को जंक्शन के साथ सिंक्रनाइज़ किया जा रहा है। इसमें थोड़ा समय लग सकता है...`)
};

const pt_pt2_team_sync_starting_info = /** @type {(inputs: Team_Sync_Starting_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando o projeto da equipe com o Junction. Isso pode levar alguns instantes...`)
};

/**
* | output |
* | --- |
* | "Syncing team project with Junction. This may take a moment..." |
*
* @param {Team_Sync_Starting_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_starting_info = /** @type {((inputs?: Team_Sync_Starting_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Starting_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_starting_info(inputs)
	if (locale === "de") return de_team_sync_starting_info(inputs)
	if (locale === "it") return it_team_sync_starting_info(inputs)
	if (locale === "ru") return ru_team_sync_starting_info(inputs)
	if (locale === "es") return es_team_sync_starting_info(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_starting_info(inputs)
	if (locale === "ja") return ja_team_sync_starting_info(inputs)
	if (locale === "hi") return hi_team_sync_starting_info(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_starting_info(inputs)
	return en_team_sync_starting_info(inputs)
});